import {
  Course,
  Degree,
  EmploymentStatus,
  Gender,
  InterviewStatus,
  MonthlySalaryExpectation,
  ReviewStatus,
  StaffType,
  Subject,
  TeacherStatus,
  TeacherType,
  TeachingEnvironment,
  WeeklyAvailableTeachingHours,
  YearsOfExperience,
} from 'constants/teacherRecruitment';

// migrate from back end
export interface ApplicationReviewDto {
  id?: string; // 有值代表更新，無值代表新增
  applyTime: string;
  regTime?: string;
  course: Course;
  interviewStatus?: InterviewStatus;
  initialReviewStatus?: ReviewStatus;
  initialReviewer?: string;
  initialReviewTime?: string;
  initialReviewMessage?: string;
  secondaryReviewStatus?: ReviewStatus;
  secondaryReviewer?: string;
  secondaryReviewTime?: string;
  secondaryReviewMessage?: string;
  secondaryReviewTeachingLevel?: string;
  secondaryReviewCourseTags?: string[];
  secondaryReviewTeachingStyles?: string[];
  teachingMaterials?: string[];
  roomId?: string;
  createdAt?: string;
  updatedAt?: string;
}
export interface PriorityBy {
  operator: string;
  operatorName: string;
  dateString: string;
}

export interface EducationBackgroundDto {
  id: string;
  schoolName: string;
  major: string;
  degree: Degree;
  startTime: string;
  endTime: string;
  stillStudying: boolean;
}
export interface WorkExperienceDto {
  jobCategory: string;
  jobTitle: string;
  companyName: string;
  startTime: string;
  endTime: string;
  stillWorking: boolean;
}

export interface JobExperienceDto {
  id?: string;
  employmentStatus?: EmploymentStatus;
  weeklyAvailableTeachingHours?: WeeklyAvailableTeachingHours;
  description?: string;
  monthlySalaryExpectation?: MonthlySalaryExpectation;
  strength?: string;
  currentPlaceOfResidence?: string;
  workExperience: WorkExperienceDto[];
}

export interface PaginationDto {
  take?: number;
  page?: number;
}
export interface TeachingCertificateDto {
  id: string;
  teacherId: string;
  issuingOrganization: string;
  certificateName: string;
  certificateFilePath: string;
}
export interface SubjectCourseDto {
  subject: Subject;
  course: Course;
}
export interface TeachingExperienceDto {
  teachingEnvironment: TeachingEnvironment;
  yearsOfExperience: YearsOfExperience;
  description: string;
}
export interface TeachingOverviewDto {
  id?: string;
  subjectCourse: SubjectCourseDto[];
  languages: string[];
  teachingExperience: TeachingExperienceDto[];
}

export enum EContractStatus {
  UNCONFIRMED,
  PENDING,
  ACCEPTED,
}
export interface TeacherRecruitmentDto {
  id?: string;
  oneClubId?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  nickName?: string;
  avatarImage?: string;
  mobileCountryCode?: string;
  mobile?: string;
  telephoneCountryCode?: string;
  telephone?: string;
  email?: string;
  nationality?: string;
  birthday?: string;
  roomId?: string;
  contractSignedTime?: string;
  turnOfficialTime?: string;
  teacherType?: TeacherType;
  gender?: Gender;
  city?: string;
  district?: string;
  address?: string;
  personalID?: string;
  bankCode?: string;
  bankName?: string;
  bankBranchCode?: string;
  bankBranchName?: string;
  bankAccount?: string;
  // teacherRecruitmentPII: CreateTeacherRecruitmentPiiDto;
  teachingOverview?: TeachingOverviewDto;
  jobExperience?: JobExperienceDto;
  educationBackground?: EducationBackgroundDto[];
  teachingCertificate?: TeachingCertificateDto[];
  applicationReview?: ApplicationReviewDto[];
  isTurnOnCrossSubjectUI?: boolean;
  contractFile?: string;
  frontIdCardFile?: string;
  backIdCardFile?: string;
  passbookFile?: string;
  // teacherStaffID 新增時自動產生 最後號 +1
  teacherStaffID?: string;
  staffType?: StaffType;
  onBoard?: number;
  status?: TeacherStatus;
  level?: number;
  star?: number;
  internalStarInternal?: number;
  // priority?: Priority;
  priorityText?: string;
  priorityBy?: PriorityBy;
  internalCommentText?: string;
  internalCommentBy?: PriorityBy;
  courseTags?: string[];
  personalTags?: string[];
  education?: string;
  teachingExperience?: string;
  introduction?: string;
  certificates?: string[];
  videos?: string[];
  createdAt?: string;
  referralCode?: string;
  referredBy?: string;
  sentTerminatedContractTime?: string;
  signedTerminatedContractTime?: string;
  terminatedContractFile?: string;
  appliedReferralCodeTime?: string;
  requestSignContractFromMMSTime?: string;
  latestApplicationSubmitTime?: string;
  contractStatus?: EContractStatus;
  contractSignedInfo?: {
    contractId: string;
    name: string;
    signedAt: string;
  } | null;
}
export interface DeleteTeacherRecruitmentRelationsDto {
  educationBackgroundIds?: string[];
  teachingCertificateIds?: string[];
}

export interface TRContractEditor {
  name?: string;
  email?: string;
  staffNumber?: string;
}

export interface TeacherRecruitmentContract {
  id: string;
  name: string;
  description?: string;
  editor?: TRContractEditor;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export interface TRContractVariable {
  id: string;
  name: string;
  htmlContent: string;
  placeHolderHtml: string;
  defaultValue: string;
}
export interface TContractEmailVariableResponse {
  name: string;
  value: string;
}
